<template>
    <div v-if="loading">
      <LoadingState></LoadingState>
    </div>
    <div v-else>
      <div class="bg-gradient-to-tr from-blue-600 via-sky-600 to-indigo-500 h-64 pt-[56px] w-full flex items-center dark:bg-gradient-to-tr dark:from-gray-900 dark:via-slate-800 dark:to-gray-900">
        <div class="container mx-auto">
          <div class="2xl:border-l-4 xl:border-l-4 lg:border-l-4 md:border-l-4 border-white dark:border-lime-600 2xl:text-start xl:text-start md:text-start text-center">
            <h1 class="font-bold text-4xl text-white mb-2 indent-2 dark:text-lime-500">{{ $t('navbar.guarantee-fund') }}</h1>
          </div>
  
          <a onclick="window.history.back()" class="text-white dark:text-lime-500 2xl:hidden xl:hidden lg:hidden md:hidden inline-flex items-center font-medium hover:text-gray-900 dark:hover:text-white cursor-pointer justify-center w-full">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4 mr-2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M9 15L3 9m0 0l6-6M3 9h12a6 6 0 010 12h-3" />
            </svg>
            <span>{{ $t('table.go-back') }}</span>
          </a>
  
          <nav aria-label="Breadcrumb" class="2xl:block xl:block lg:block md:block hidden">
            <ol class="flex space-x-1 md:space-x-3 text-white dark:text-lime-500">
              <li class="flex items-center hover:text-gray-900 dark:hover:text-white cursor-pointer hover:color-gray-900">
                <a @click="this.$router.push('/')" class="inline-flex items-center font-medium">
                  <svg class="w-4 h-4 mr-2" fill="white" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"></path>
                  </svg>
                  <span class="hidden sm:block">{{ $t('ceo-message.main-screen') }}</span>
                </a>
              </li>
              <li aria-current="page">
                <div class="flex items-center">
                  <svg class="w-6 h-6 text-gray-400" fill="white" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd"
                          d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                          clip-rule="evenodd"></path>
                  </svg>
                  <span class="ml-1 font-medium md:ml-2 select-none">{{ $t('navbar.guarantee-fund') }}</span>
                </div>
              </li>
            </ol>
          </nav>
        </div>
      </div>
      <div class="container mx-auto border dark:border-lime-600 m-5 rounded-xl shadow py-5 bg-slate-50/25 dark:bg-gray-777">
        <div class="dark:py-5 2xl:px-48 xl:px-24 lg:px-10 px-5 dark:bg-gray-900">

            
          <div class="flex flex-col w-full container mx-auto">
            
            <div class="flex items-center space-x-4">
                <div class="relative">
                    <input
                    type="date"
                    id="start-date"
                    :min="minDate"
                    v-model="startDate"
                    class=" block w-40 px-4 py-2 text-gray-500 bg-white border border-gray-300 rounded-md shadow-sm focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                    />
                   
                </div>
                <button v-if="startDate"
                    @click="SearchClear()"
                    class="flex items-center justify-center px-3 py-1 text-white bg-gradient-to-r from-red-500 to-red-700 rounded-md text-sm font-medium hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-red-300 dark:focus:ring-red-800"
                >
                X
                </button>
                <button
                    @click="SearchGuaranteeFund()"
                    class="flex items-center justify-center px-5 py-2 text-white bg-gradient-to-r from-blue-500 to-blue-700 rounded-md text-sm font-medium hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800"
                >
                {{ $t('table.search-time') }}
                </button>
            </div>
            <div class="accordion-content p-1 text-gray-700 bg-white dark:bg-gray-777 dark:border-lime-500 border my-1 border-blue-500 rounded-lg">
                  <div class="flex flex-col w-full">
                    <div class="overflow-x-auto sm:-mx-6 lg:-mx-8">
                      <div class="align-middle inline-block min-w-full sm:px-6 lg:px-8">
                        <div class="border overflow-hidden border-b border-gray-200 sm:rounded-lg">
                            
                          <table class="min-w-full divide-y divide-gray-200">
                            <thead class="bg-gray-100">
                            <tr>
                              <th scope="col"
                                  class="px-3 py-2 text-center text-xs font-bold text-black uppercase tracking-wider w-32">
                                  {{ $t('table.time') }}
                              </th>
                              <th scope="col"
                                  class="px-3 py-2 text-center text-xs font-bold text-black uppercase tracking-wider w-32">
                                  {{ $t('table.code') }}
                              </th>
                              <th scope="col"
                                  class="px-3 py-2 text-center text-xs font-bold text-black uppercase tracking-wider">
                               {{ $t('table.name') }}
                              </th>
                              <th scope="col"
                                  class="px-3 py-2 text-center text-xs font-bold text-black uppercase tracking-wider w-32">
                               {{ $t('table.fund') }}
                              </th>
                              <th scope="col"
                                  class="px-3 py-2 text-center text-xs font-bold text-black uppercase tracking-wider w-32">
                               {{ $t('table.currency') }}
                              </th>
                            </tr>
                            </thead>
                            <tbody v-for="(item, index) in guaranteeFundUZS"
                                   :key="index">
                                   <tr class="h-4">
                              <td
                                  class="whitespace-nowrap text-sm text-black font-mono text-center w-32">
                                  {{ formatDate(item.date) }}
                              </td>
                              <td
                                  class="px-3 py-2 whitespace-nowrap text-sm text-black border-x">
                                  {{ item.code }}
                              </td>
                              <td
                                  class="px-3 py-2 whitespace-nowrap text-sm text-black border-x">
                                  {{ item.name }}
                              </td>
                              <td
                                  class="px-3 py-2 whitespace-nowrap text-sm text-black border-x">
                                  {{ formatNumberWithComma(item.fund) }}
                              </td>
                              <td
                                  class="px-3 py-2 whitespace-nowrap text-sm text-black border-x">
                                  {{ item.currency }}
                              </td>
                            </tr>
                            </tbody>
                            <tr v-show="guaranteeFundUZS.length == 0">
                              <td colspan="6"
                                  class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-lime-500">
                                {{ $t('table.doesnt-exist') }}
                              </td>
                            </tr>
                            <tr v-if="totalFundUZS > 0" class="bg-gray-50 border-t">
                                <td colspan="3" class="px-6 py-4 text-sm font-semibold text-gray-700"> </td>
                                <td colspan="4" class="px-6 py-4 text-sm font-semibold text-gray-700">{{"UZS " + formatNumberWithComma(totalFundUZS) }}</td>
                            </tr>
                          </table>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
<!-- USD -->
            <div class="flex flex-col w-full container mx-auto py-10">
                <div class="accordion-content p-1 text-gray-700 bg-white dark:bg-gray-777 dark:border-lime-500 border my-1 border-blue-500 rounded-lg">
                  <div class="flex flex-col w-full">
                    <div class="overflow-x-auto sm:-mx-6 lg:-mx-8">
                      <div class="align-middle inline-block min-w-full sm:px-6 lg:px-8">
                        <div class="border overflow-hidden border-b border-gray-200 sm:rounded-lg">
                          <table class="min-w-full divide-y divide-gray-200">
                            <thead class="bg-gray-100">
                              <tr>
                              <th scope="col"
                                  class="px-3 py-2 text-center text-xs font-bold text-black uppercase tracking-wider w-32">
                                  {{ $t('table.time') }}
                              </th>
                              <th scope="col"
                                  class="px-3 py-2 text-center text-xs font-bold text-black uppercase tracking-wider w-32">
                                  {{ $t('table.code') }}
                              </th>
                              <th scope="col"
                                  class="px-3 py-2 text-center text-xs font-bold text-black uppercase tracking-wider">
                               {{ $t('table.name') }}
                              </th>
                              <th scope="col"
                                  class="px-3 py-2 text-center text-xs font-bold text-black uppercase tracking-wider w-32">
                               {{ $t('table.fund') }}
                              </th>
                              <th scope="col"
                                  class="px-3 py-2 text-center text-xs font-bold text-black uppercase tracking-wider w-32">
                               {{ $t('table.currency') }}
                              </th>
                            </tr>
                            </thead>
                            <tbody v-for="(item, index) in guaranteeFundUSD"
                                   :key="index">
                                   <tr class="h-4">
                              <td
                                  class="whitespace-nowrap text-sm text-black font-mono text-center w-32">
                                  {{ formatDate(item.date) }}
                              </td>
                              <td
                                  class="px-3 py-2 whitespace-nowrap text-sm text-black border-x">
                                  {{ item.code }}
                              </td>
                              <td
                                  class="px-3 py-2 whitespace-nowrap text-sm text-black border-x">
                                  {{ item.name }}
                              </td>
                              <td
                                  class="px-3 py-2 whitespace-nowrap text-sm text-black border-x">
                                  {{ formatNumberWithComma(item.fund) }}
                              </td>
                              <td
                                  class="px-3 py-2 whitespace-nowrap text-sm text-black border-x">
                                  {{ item.currency }}
                              </td>
                            </tr>
                            </tbody>
                            <tr v-show="guaranteeFundUSD.length == 0">
                              <td colspan="6"
                                  class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-lime-500">
                                {{ $t('table.doesnt-exist') }}
                              </td>
                            </tr>
                            <tr v-if="totalFundUSD > 0" class="bg-gray-50 border-t">
                                <td colspan="3" class="px-6 py-4 text-sm font-semibold text-gray-700">  </td>
                                <td colspan="4" class="px-6 py-4 text-sm font-semibold text-gray-700">{{"USD " + formatNumberWithComma(totalFundUSD) }}</td>
                            </tr>
                          </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
<!-- EUR -->

<div class="flex flex-col w-full container mx-auto">
            <div class="accordion-content p-1 text-gray-700 bg-white dark:bg-gray-777 dark:border-lime-500 border my-1 border-blue-500 rounded-lg">
                  <div class="flex flex-col w-full">
                    <div class="overflow-x-auto sm:-mx-6 lg:-mx-8">
                      <div class="align-middle inline-block min-w-full sm:px-6 lg:px-8">

                        <div class="border overflow-hidden border-b border-gray-200 sm:rounded-lg">
                          <table class="min-w-full divide-y divide-gray-200">
                            <thead class="bg-gray-100">
                              <tr>
                              <th scope="col"
                                  class="px-3 py-2 text-center text-xs font-bold text-black uppercase tracking-wider w-32">
                                  {{ $t('table.time') }}
                              </th>
                              <th scope="col"
                                  class="px-3 py-2 text-center text-xs font-bold text-black uppercase tracking-wider w-32">
                                  {{ $t('table.code') }}
                              </th>
                              <th scope="col"
                                  class="px-3 py-2 text-center text-xs font-bold text-black uppercase tracking-wider">
                               {{ $t('table.name') }}
                              </th>
                              <th scope="col"
                                  class="px-3 py-2 text-center text-xs font-bold text-black uppercase tracking-wider w-32">
                               {{ $t('table.fund') }}
                              </th>
                              <th scope="col"
                                  class="px-3 py-2 text-center text-xs font-bold text-black uppercase tracking-wider w-32">
                               {{ $t('table.currency') }}
                              </th>
                            </tr>
                            </thead>
                            <tbody v-for="(item, index) in guaranteeFundEUR"
                                   :key="index">
                            <tr class="h-4">
                              <td
                                  class="whitespace-nowrap text-sm text-black font-mono text-center w-32">
                                  {{ formatDate(item.date) }}
                              </td>
                              <td
                                  class="px-3 py-2 whitespace-nowrap text-sm text-black border-x">
                                  {{ item.code }}
                              </td>
                              <td
                                  class="px-3 py-2 whitespace-nowrap text-sm text-black border-x">
                                  {{ item.name }}
                              </td>
                              <td
                                  class="px-3 py-2 whitespace-nowrap text-sm text-black border-x">
                                  {{ formatNumberWithComma(item.fund) }}
                              </td>
                              <td
                                  class="px-3 py-2 whitespace-nowrap text-sm text-black border-x">
                                  {{ item.currency }}
                              </td>
                            </tr>
                            </tbody>
                            <tr v-show="guaranteeFundUSD.length == 0">
                              <td colspan="6"
                                  class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-lime-500">
                                {{ $t('table.doesnt-exist') }}
                              </td>
                            </tr>
                            <tr v-if="totalFundEUR > 0" class="bg-gray-50 border-t">
                                <td colspan="3" class="px-6 py-4 text-sm font-semibold text-gray-700">  </td>
                                <td colspan="4" class="px-6 py-4 text-sm font-semibold text-gray-700">{{"EUR " + formatNumberWithComma(totalFundEUR) }}</td>
                            </tr>
                          </table>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>


                </div>
            </div>
        </div>
  </template>
  
  <script>
  import LoadingState from "@/components/LoadingState";
  import { toast } from "vue3-toastify";
  import axios from 'axios'
  
  export default {
    components: {
      LoadingState
    },
      data() {
          return {
            guaranteeFundUZS:[],
            guaranteeFundUSD:[],
            guaranteeFundEUR:[],
            startDate:null,
            minDate:"2025-04-22",
            loading: true
          };
      },
      methods: {
        loadTableForCurrency(currency) {
      axios
        .get(`/api/Website/GuaranteeFund/Get${currency}ByDate/${this.startDate}`)
        .then((response) => {
          if (currency === "EUR") {
            this.guaranteeFundEUR = response.data;
          } else if (currency === "USD") {
            this.guaranteeFundUSD = response.data;
          } else if (currency === "UZS") {
            this.guaranteeFundUZS = response.data;
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
        loadTableUZS() {
              axios
                  .get(`/api/Website/GuaranteeFund/GetLastUZS`)
                  .then((response) => {
                      this.guaranteeFundUZS = response.data;
                  })
                  .catch((error) => {
                      console.log(error);
                  })
                  .finally(() => {
                    this.loading = false;
                  });
          },
        loadTableUSD() {
              axios
                  .get(`/api/Website/GuaranteeFund/GetLastUSD`)
                  .then((response) => {
                      this.guaranteeFundUSD = response.data;
                  })
                  .catch((error) => {
                      console.log(error);
                  })
                  .finally(() => {
                    this.loading = false;
                  });
          },
        
        loadTableEUR() {
              axios
                  .get(`/api/Website/GuaranteeFund/GetLastEUR`)
                  .then((response) => {
                      this.guaranteeFundEUR = response.data;
                  })
                  .catch((error) => {
                      console.log(error);
                  })
                  .finally(() => {
                    this.loading = false;
                  });
          },
          SearchGuaranteeFund() {
            if (!this.startDate) {
                toast.error("Выберите дата", {
              position: "top-center",
              transition: "flip",
              newestOnTop: true,
            });
            }

            this.loading = true;
            this.loadTableForCurrency("UZS");
            this.loadTableForCurrency("USD");
            this.loadTableForCurrency("EUR");
    },
    SearchClear(){
        this.startDate = '';
        this.loadTableUZS();
        this.loadTableUSD();
        this.loadTableEUR();
    },
    formatNumberWithComma(value) {
      return new Intl.NumberFormat('en-US').format(value);
    },
    formatDate(date) {
      const [year, month, day] = date.split('-');
      return `${day}.${month}.${year}`;
    }
        
      },
      computed: {
            totalFundUZS() {
                let total = 0;
                this.guaranteeFundUZS.forEach(item => {
                    total += item.fund;
                });
                return total.toFixed(2);
            },
            totalFundUSD() {
                let total = 0;
                this.guaranteeFundUSD.forEach(item => {
                    total += item.fund;
                });
                return total.toFixed(2);
            },
            totalFundEUR() {
                let total = 0;
                this.guaranteeFundEUR.forEach(item => {
                    total += item.fund;
                });
                return total.toFixed(2);
            },
        },

      mounted() {
          this.loadTableUZS();
          this.loadTableUSD();
          this.loadTableEUR();
      },
  };
  </script>